import React from 'react'
import {i18n, exportToFile, Http} from 'common'
import {DataTable, Row, Toolbar, Search, Button, FormattedDate} from '../components'


export default class Support extends React.PureComponent {
    state = {
        searchEnabled: true,
        searchQuery: null,
        items: null
    }

    onRenderRow = (item, index) => (
        <Row key={index}>
            <td>{item.provider}</td>
            <td>{item.email}</td>
            <td className="txtcenter">
                <FormattedDate>{item.validUntil}</FormattedDate>
            </td>
        </Row>
    )

    onSearchChange = e =>
        this.setState({searchQuery: e.target.value})

    onSearchSubmit = () => {
        const {searchQuery: userId, searchEnabled} = this.state

        if (!searchEnabled) {
            return null
        }

        const url = `api/users/${userId}/idproviders`

        Http.GET(url, (data) => {
            this.setState({items: data, searchEnabled: false})
            setTimeout(() => this.setState({searchEnabled: true}), 60 * 1000)
        })
    }

    onExport = () => {
        exportToFile(this.state.items)
    }


    render() {
        const {items, searchEnabled} = this.state
        return (
            <div className='box'>
                <Toolbar>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <span>Search By ClientID </span>
                        <Search
                            placeholder='Search...'
                            style={{marginLeft: '10px'}}
                            onChange={this.onSearchChange}
                        />
                        <Button
                            type={!searchEnabled ? 'disabled' : undefined}
                            title='Search'
                            icon='search'
                            onClick={this.onSearchSubmit}
                            style={{marginLeft: '5px'}}
                        />

                        <Button
                            title='Export'
                            icon='arrow-down'
                            onClick={this.onExport}
                            style={{marginLeft: '25px'}}
                        />
                    </div>
                </Toolbar>

                {items &&
                    <DataTable
                        items={items}
                        onRenderRow={this.onRenderRow}
                    />
                }
            </div>
        )
    }
}
